import { render } from "./ITeamMultiPicker.vue?vue&type=template&id=0bbafe02"
import script from "./ITeamMultiPicker.vue?vue&type=script&lang=js"
export * from "./ITeamMultiPicker.vue?vue&type=script&lang=js"

import "./ITeamMultiPicker.vue?vue&type=style&index=0&id=0bbafe02&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__